import { CommonModule } from '@angular/common';
import { Component, signal, inject } from '@angular/core';
import { Router, RouterModule, RouterOutlet, NavigationEnd } from '@angular/router';
import { Sidebar } from './shared/components/sidebar/sidebar';
import { FooterComponent } from './shared/components/footer/footer';
import { AiChatTriggerComponent } from './shared/components/ai-chat-trigger/ai-chat-trigger';
import { NotificationPanelComponent } from './shared/components/notification-panel/notification-panel';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, CommonModule, Sidebar, FooterComponent, AiChatTriggerComponent, NotificationPanelComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('ISG-Banxx');
  showLayout = signal(this.checkInitialLayout());

  private router = inject(Router);

  constructor() {
    // Listen to route changes to update layout state dynamically
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateLayoutState(event.urlAfterRedirects || event.url);
    });
  }

  private checkInitialLayout(): boolean {
    if (typeof window === 'undefined') return true;
    const path = window.location.pathname;
    return !(path.includes('/request-consent') || path.includes('/consent-callback'));
  }

  private updateLayoutState(url: string) {
    // Hide sidebar/footer for both request-consent and consent-callback pages
    const isConsentPage = url.includes('/request-consent') || url.includes('/consent-callback');

    // We show the layout (sidebar/footer/chat) for everything EXCEPT consent pages
    this.showLayout.set(!isConsentPage);
  }
}
